import { WBTypography } from "@apptractive/design-system-web";
import { useTranslation } from "react-i18next";
import { PageContainer } from "../../components/PageContainer";
import OnboardingUserForm from "./OnboardingUserForm";

const OnboardingUser = () => {
  const { t } = useTranslation();
  return (
    <PageContainer
      sx={{
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <WBTypography variant="h1">
        {t("createYourProfile", { ns: "onboarding" })}
      </WBTypography>
      <OnboardingUserForm />
    </PageContainer>
  );
};

export default OnboardingUser;
